export default class Form {
	constructor() {
		this.$document = $(document);
		this.activeClass = 'js-is-active';
		this.hiddenClass = 'js-is-hidden';
	}

	onFocusOut(event) {
		const $elm = $(event.currentTarget);
		const value = $elm.val() != "" ? true : false;

		$elm.toggleClass(this.activeClass, value);
	}

	onChange(event){
		const $elm = $(event.currentTarget);
		const value = $elm.val() != "" ? true : false;

		$elm
			.closest('.nf-field-element')
			.toggleClass(this.activeClass, value);
	}

	setEventBindings() {
		this.$document.on('focusout', 'input[type="text"], input[type="email"], input[type="tel"], textarea', this.onFocusOut.bind(this));
		this.$document.on('change', 'select', this.onChange.bind(this));
	}

	init() {
		this.setEventBindings();
	}
}


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/components/Form.js